import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./auth";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { QuizList } from "./pages/QuizList";
import { QuizDetail } from "./pages/QuizDetail";
import { Preview } from "./pages/Preview";
import { Analytics } from "./pages/Analytics";
import { StoryAnalytics } from "./pages/StoryAnalytics";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/quizzes" replace />} />
        <Route path="/quizzes" element={<QuizList />} />
        <Route path="/quizzes/:slug" element={<QuizDetail />} />
        <Route path="/quizzes/:slug/preview" element={<Preview />} />
        <Route path="/quizzes/:slug/analytics" element={<StoryAnalytics />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="*" element={<Navigate to="/quizzes" replace />} />
      </Route>
    </Routes>
  );
}
